var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263F54",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.303 25.774c0 1.641-1.477 2.968-3.303 2.968s-3.302-1.327-3.302-2.968c0-2.396 3.302-5.38 3.302-5.38s3.302 2.839 3.302 5.38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20 11.25-2.685 5.195-2.023-1.005c-1.503 1.801-2.792 4.07-2.792 6.57 0 3.724 3.356 6.74 7.5 6.74s7.5-3.016 7.5-6.74c-.009-5.75-7.5-10.76-7.5-10.76"
  })));
};
export default SvgFire;